export default "__VITE_ASSET__f1357dbe__"